import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { StringFormatter } from '@repo/toolkit/string'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'
import { useFormContext } from 'react-hook-form'

import { GenderEnum, genderOptionsMapping } from '../../../lib/types/enums/common/gender.enum'
import { InformationRequestInput } from '../../../lib/types/models/information-request/information-request-input'
import { FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'
import ControlledRadioInput from '../../elements/inputs/controlled-radio-input'

type InformationRequestParentFormProps = {
  required?: boolean
}

const InformationRequestParentForm = ({ required }: InformationRequestParentFormProps) => {
  const form = useFormContext<InformationRequestInput>()

  return (
    <InnerBox title="Information du parent">
      <div className="flex flex-col gap-3 ">
        <div className="flex flex-col gap-1">
          <Typography variant="label" color={tailwindColors.grey.lighter}>
            {StringFormatter.isRequired('Genre :', required)}
          </Typography>
          <div className="flex gap-5">
            {Object.values(GenderEnum).map((gender) => (
              <FormField
                key={gender}
                control={form.control}
                name="parentGender"
                render={({ field }) => {
                  return (
                    <FormItem>
                      <FormControl>
                        <ControlledRadioInput
                          {...field}
                          label={genderOptionsMapping[gender].title}
                          checked={field.value === gender}
                          onCheck={() => field.onChange(gender)}
                        />
                      </FormControl>
                    </FormItem>
                  )
                }}
              />
            ))}
          </div>
        </div>
        <FormField
          control={form.control}
          name="parentLastName"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <ControlledInput {...field} label="NOM" type="text" required={required} />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="parentFirstName"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <ControlledInput {...field} label="Prénom" type="text" required={required} />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
    </InnerBox>
  )
}

export default InformationRequestParentForm
